import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { useUserAdmin } from "../hooks/useUserAdmin";
import UserForm from "./UserForm";
import UserGrid from "./UserGrid";

function UserAdmin() {
  const {
    open,
    editMode,
    currentUser,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
  } = useUserAdmin();

  return (
    <WidgetWrapper>
      <FlexBetween>
        <Typography variant="h5">Users</Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{
            borderRadius: "5px",
            fontSize: "12px",
            padding: "5px 10px",
          }}
          onClick={handleOpen}
        >
          <PersonAddAltOutlinedIcon sx={{ mr: "0.5rem" }} />
          Add new User
        </Button>
      </FlexBetween>

      <UserGrid handleEditOpen={handleEditOpen} />

      {/* The Dialog component is a modal dialog that is displayed over the current page. */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editMode
            ? `Edit User - ${currentUser.firstName} ${currentUser.lastName}`
            : "Add a New User to your Organisation"}
        </DialogTitle>
        <DialogContent>
          <UserForm
            editMode={editMode}
            currentUser={currentUser}
            setOpen={setOpen}
            handleClose={handleClose}
          />
        </DialogContent>
      </Dialog>
    </WidgetWrapper>
  );
}

export default UserAdmin;
